import { MatDialog } from '@angular/material/dialog';

import { ConfirmDialogComponent } from '@shared/components';
import { StaticMessage } from '@shared/enums';
import { Constants, getStaticMessage } from '@shared/utils';

/** Opens the validation error dialog for the named table or status tracker. */
export function openValidationErrorDialog(
  dialog: MatDialog,
  name: string,
  message: string
): void {
  dialog.open(ConfirmDialogComponent, {
    ...Constants.DialogOptions,
    data: {
      extra: name,
      title: getStaticMessage(StaticMessage.ValidationErrorTitle),
      message,
      buttonLabel: getStaticMessage(StaticMessage.OkButton),
      hideCancelButton: true,
    },
  });
}
